import { checkIsPlatformAdmin } from './authRoles';
import { normalizePanelTabIds } from './adminPanelTabs';

const EMPTY_ACCESS = {
  isOwner: false,
  tabs: [],
  ownerUserId: null,
};

let cachedPanelAccess = null;
let cachedUserId = null;

export function getCachedPanelAccess() {
  return cachedPanelAccess;
}

export function clearPanelAccessCache() {
  cachedPanelAccess = null;
  cachedUserId = null;
}

function rememberPanelAccess(userId, access) {
  cachedUserId = userId;
  cachedPanelAccess = access;
}

/**
 * @returns {Promise<{ isOwner: boolean, tabs: string[]|null, ownerUserId: string|null }>}
 */
export async function fetchPanelAccess(supabase) {
  const { data: { user } } = await supabase.auth.getUser();
  if (!user?.id) {
    clearPanelAccessCache();
    return { ...EMPTY_ACCESS };
  }

  if (cachedUserId === user.id && cachedPanelAccess) {
    return cachedPanelAccess;
  }

  let access = { ...EMPTY_ACCESS };

  if (await checkIsPlatformAdmin(supabase, user)) {
    access = {
      isOwner: true,
      tabs: null,
      ownerUserId: user.id,
    };
  } else {
    const { data: payload, error } = await supabase.rpc('get_my_panel_access');
    if (!error && payload) {
      if (payload.is_owner === true) {
        access = {
          isOwner: true,
          tabs: null,
          ownerUserId: user.id,
        };
      } else {
        const tabs = normalizePanelTabIds(payload.tabs);
        if (tabs.length) {
          access = {
            isOwner: false,
            tabs,
            ownerUserId: payload.owner_user_id || null,
          };
        }
      }
    }
  }

  rememberPanelAccess(user.id, access);
  return access;
}

export function hasPanelAccess(access) {
  if (!access) return false;
  return access.isOwner || (Array.isArray(access.tabs) && access.tabs.length > 0);
}

/** User id stored on owner-scoped rows (shifts, checklist, …). */
export function panelOwnerUserId(access, sessionUserId) {
  if (!access) return sessionUserId ?? null;
  if (access.ownerUserId) return access.ownerUserId;
  return sessionUserId ?? null;
}
